import React from 'react';
import type { CompanyPrintInfo } from '@/components/sales-invoice/PrintableSalesInvoice';
import type { DeliveryPrintData } from '@/services/delivery.service';
import type { DeliveryPrintLetterheadVariant } from './DeliveryNotePrintView';
import { EngineCommercialInvoicePrint } from '@/components/print/EngineLetterheadPrints';

/** Commercial invoice from delivery note — shared pagination engine (no VAT). */
export function DeliveryCommercialInvoicePrintView({
  data,
  companyInfo = { name: 'Company' },
  printVariant = 'letterhead',
  onClose,
}: {
  data: DeliveryPrintData;
  companyInfo?: CompanyPrintInfo;
  printVariant?: DeliveryPrintLetterheadVariant;
  onClose?: () => void;
}) {
  return (
    <EngineCommercialInvoicePrint
      data={data}
      companyInfo={companyInfo}
      printVariant={printVariant}
      onClose={onClose}
    />
  );
}
